// @flow
import getHexColorComponents from './getHexColorComponents';
import getCSSHexColor from './getCSSHexColor';

/**
 * Darkens a CSS color by the amount given. The `lightenByAmount` value is a scale from 0 to 1 where
 * 0 means "don't lighten at all" (which returns the same color) and 1 means "lighten completely"
 * (which means return white.)
 *
 * @param hexColor - A 6-digit CSS hex color
 * @param lightenByAmount - A number between 0 and 1 indicating how much to lighten by
 * @return A 6-digit CSS hex color lightened by the requested amount
 */
const lighten = (hexColor: string, lightenByAmount: number): string => {
  const { red, green, blue } = getHexColorComponents(hexColor);
  const newRed = red + Math.round((255 - red) * lightenByAmount);
  const newGreen = green + Math.round((255 - green) * lightenByAmount);
  const newBlue = blue + Math.round((255 - blue) * lightenByAmount);
  return getCSSHexColor(newRed, newGreen, newBlue);
};

export default lighten;
